<template>
    <div>
        <v-layout row wrap class="quem">
            <v-flex class="titulo-centro">
                <h2 class="gracias"> Obrigado por baixar nosso guia! </h2>

                <div class="risquinho-centro"></div>

                <p> Acompanhe-nos nas redes sociais!</p>
            </v-flex>
        </v-layout>

        <v-content  id="contact" class="contato">
            <v-container fluid>
                <Contato/>
            </v-container>
        </v-content>
    </div>

</template>

<script>
    import Contato from './Contato'

    export default {
        components:{ Contato },
        name: "Valeu",

        methods: {
            register (){
                // window.fbq('track', 'Lead');
            },
        },

        created() {
            this.register()
        }
    }
</script>

<style scoped>
.gracias {
    padding-top: 15px;
}
</style>